module.exports = __webpack_public_path__ + "media/images/www/company/user-network-b2fb70bc471797db7dc16a6283a1ad7d.svg";